// extracted by mini-css-extract-plugin
export default {"root_image_inner":"newscategoryUpdationForm_root_image_inner__B2qav","FormTabs_root":"newscategoryUpdationForm_FormTabs_root__-wmaO"};